<mat-form-field class="chip-list" appearance="outline">
	@if (label) {
		<mat-label>{{label}}</mat-label>
	}
	<mat-chip-grid class="chip-grid" #chipGrid aria-label="Enter items">
	  @for (item of content; track item) {
		<mat-chip-row
		  (removed)="remove(item)"
		  [editable]="true"
		  (edited)="edit(item, $event)"
		  [aria-description]="'general.press_enter_to_edit'| translateWithKeys: { params: { item:(item.name ?? item) } }">
		  {{item.name ?? item}}
		  <button matChipRemove [attr.aria-label]="'remove_chip' | translateWithKeys: { params: { item:(item.name ?? item) } }">
			<mat-icon>cancel</mat-icon>
		  </button>
		</mat-chip-row>
	  }
	  <input class="input-chips" placeholder="{{placeholder}}"
			 [matChipInputFor]="chipGrid"
			 [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
			 [matChipInputAddOnBlur]="addOnBlur"
			 (matChipInputTokenEnd)="add($event)"
			 maxlength="20"/>
	</mat-chip-grid>
  </mat-form-field>
